import React from 'react'
import { Form } from 'semantic-ui-react'

const Input = ({ label, value, onChange, isNumber, hasError, disabled, required }) => {
  const errorMessage = hasError ? isNumber ? 'is invalid' : 'can\'t be blank' : ''
  const step = isNumber ? { step: 'any' } : {}

  return (
    <Form.Field>
      <label>{label}</label>
      <input
        placeholder={label}
        value={value}
        onChange={onChange}
        type={isNumber ? 'number' : 'text'}
        style={hasError ? { borderColor: 'red' } : {}}
        {...step}
        disabled={disabled}
        required
      />
      <span style={{ color: 'red' }}>{errorMessage}</span>
    </Form.Field>
  )
}

export default Input


// WEBPACK FOOTER //
// ./src/components/common/input.js